import Module from '../module';
import scroll from '../../libs/scroll/scroll';

import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface } from '../../libs/slider/slider-list-cut';

interface OptionsInterface {
	cssId: {
		anim?: {
			homeInvestmentMediaCarouselArrowLeftId: string;
			homeInvestmentMediaCarouselArrowRightId: string;
			homeInvestmentMediaCarouselPagerWrapperId: string;
			homeInvestmentMediaCarouselId: string;
		}
	},

	sliderListCutSetup?: SliderListCutSetupInterface

	slug: string
}

class Investment extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home Investment Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.sliderListCutSetup) {
			this.errorMsg('sliderSetup is not defined');
		} else {
			const slider = sliderListCutFactory.create();
			slider.init(this.publicVars.sliderListCutSetup);
		}

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeInvestmentMediaCarouselArrowLeftId || '', 'home_investment', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeInvestmentMediaCarouselArrowRightId || '', 'home_investment', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeInvestmentMediaCarouselPagerWrapperId || '', 'home_investment', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeInvestmentMediaCarouselId || '', 'home_investment', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Investment;